import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import Loader from 'Common/components/Loader';
import MeasureTasksTable from 'Employee/components/View/Measure/MeasureTasksTable';
import getPendingMeasureTasksByEmployee from 'Measure/api/getPendingMeasureTasksByEmployee';
import getPendingMeasureTasks from 'Measure/api/getPendingMeasureTasks';
import useAxiosRequest from 'Common/hooks/useAxiosRequest';
import RetryLoading from 'Common/components/RetryLoading';
import OuterBox from 'Common/components/Boxes/OuterBox';

const Wrapper = styled(OuterBox)`
    display: flex;
    flex-direction: column;
    padding: 20px 0;
`;

const LoaderWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
`;

const PendingEmployeeMeasureTasks = ({ employeeId }) => {
    const measureTasksRequest = useCallback(
        cancelToken => {
            if (employeeId) {
                return getPendingMeasureTasksByEmployee(
                    employeeId,
                    cancelToken,
                );
            }

            return getPendingMeasureTasks(cancelToken);
        },
        [employeeId],
    );

    const {
        data: measureTasks,
        loadData: loadMeasureTasks,
        isLoading,
        hasError,
    } = useAxiosRequest(measureTasksRequest, []);

    return (
        <Wrapper>
            {isLoading ? (
                <LoaderWrapper>
                    <Loader />
                </LoaderWrapper>
            ) : hasError ? (
                <RetryLoading onRetry={loadMeasureTasks} />
            ) : (
                <MeasureTasksTable
                    measureTasks={measureTasks}
                    employeeId={employeeId}
                />
            )}
        </Wrapper>
    );
};

PendingEmployeeMeasureTasks.defaultProps = {
    employeeId: null,
};

PendingEmployeeMeasureTasks.propTypes = {
    employeeId: PropTypes.number,
};

export default PendingEmployeeMeasureTasks;
